import { useEffect, useRef } from 'react';

const QA_KEY_STORAGE = 'svod_qa_key';

// Случайный ключ участника: позволяет голосовать один раз и видеть свои вопросы. Не персональные данные.
export function getParticipantKey() {
    try {
        let key = localStorage.getItem(QA_KEY_STORAGE);
        if (key && /^[A-Za-z0-9_-]{8,64}$/.test(key)) return key;
        const bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        key = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
        localStorage.setItem(QA_KEY_STORAGE, key);
        return key;
    } catch {
        return `tmp${Math.random().toString(36).slice(2, 14)}`;
    }
}

export function qaParticipantUrl(sessionRef) {
    return `${window.location.origin}/qa/${sessionRef}`;
}

// Подписка на обновления сессии вопросов через WebSocket; onChange вызывается с небольшой задержкой,
// чтобы серия событий (например, несколько голосов подряд) приводила к одной перезагрузке списка.
export function useQaUpdates(sessionRef, onChange) {
    const callbackRef = useRef(onChange);
    callbackRef.current = onChange;

    useEffect(() => {
        if (!sessionRef) return undefined;
        let socket = null;
        let reconnectTimer = null;
        let debounceTimer = null;
        let attempts = 0;
        let closed = false;

        const connect = () => {
            const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
            socket = new WebSocket(`${protocol}//${window.location.host}/ws/public/qa/${sessionRef}`);
            socket.onopen = () => { attempts = 0; };
            socket.onmessage = (event) => {
                try {
                    const message = JSON.parse(event.data);
                    if (message.type === 'qa_changed') {
                        clearTimeout(debounceTimer);
                        debounceTimer = setTimeout(() => callbackRef.current(), 250);
                    }
                } catch {
                    // игнорируем чужие сообщения
                }
            };
            socket.onclose = (event) => {
                if (closed) return;
                // Случайный разброс: после перезапуска сервера клиенты не переподключаются разом
                const base = event.code === 1013 ? 30000 : Math.min(1000 * 2 ** attempts, 30000);
                const delay = base * (0.5 + Math.random());
                attempts += 1;
                reconnectTimer = setTimeout(() => {
                    // После переподключения могли пропустить события — перечитываем список.
                    callbackRef.current();
                    connect();
                }, delay);
            };
        };

        connect();
        return () => {
            closed = true;
            clearTimeout(reconnectTimer);
            clearTimeout(debounceTimer);
            if (socket) socket.close();
        };
    }, [sessionRef]);
}
